import PaperIcon from '@/common/assets/icons/paperIcon.svg?react';
import SmallCarIcon from '@/common/assets/icons/smallCarIcon.svg?react';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import MainLayout from '@/common/components/layouts/MainLayout';
import LoadingPage from '@/common/pages/LoadingPage';
import getDamagedTypeQueryOption from '@/common/queries/getDamagedType/getDamagedTypeQueryOPtion';
import SwitchTab from '@/modules/adjusterReportModules/IncidentParticipants/components/common/SwitchTab';
import ShowAdjusterAttachedVehicleImages from '@/modules/adjusterReportModules/IncidentParticipants/components/damaged/propertyDamage/images/adjusterImages/showAccidentAttachment/ShowAdjusterAttachedVehicleImages';
import ShowDamagedDocumentImagesTab from '@/modules/adjusterReportModules/IncidentParticipants/components/damaged/propertyDamage/images/adjusterImages/showAccidentAttachment/ShowDamagedDocumentImagesTab';
import ShowDamagedOtherAttachedImagesTab from '@/modules/adjusterReportModules/IncidentParticipants/components/damaged/propertyDamage/images/adjusterImages/showAccidentAttachment/ShowDamagedOtherAttachedImagesTab';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';

export default () => {
  return (
    <MainLayout
      title="زیان‌دیده / تصاویر"
      header="titleHeader"
      hasBottomPadding
    >
      <ShowAdjusterAttachedImages />
    </MainLayout>
  );
};

const ShowAdjusterAttachedImages = () => {
  const { damagedId } = useParams();
  const [activeTab, setActiveTab] = useState(1);
  const { data: damagedInfo, isPending } = useQuery(
    getDamagedTypeQueryOption({
      damaged_pk: damagedId,
    }),
  );
  const firstTabElement =
    damagedInfo?.damaged_type === 'VEHICLE' ? (
      <ShowAdjusterAttachedVehicleImages userType="damaged" />
    ) : (
      <ShowDamagedOtherAttachedImagesTab />
    );
  const tabs = [
    {
      title:
        damagedInfo?.damaged_type === 'VEHICLE'
          ? 'تصاویر وسیله‌نقلیه'
          : 'تصاویر زیان‌دیده',
      activeTabIndex: 1,
      icon: <SmallCarIcon stroke={'currentColor'} />,
    },
    {
      title: 'تصاویر مدارک',
      activeTabIndex: 2,
      icon: <PaperIcon stroke={'currentColor'} />,
    },
  ];
  if (isPending) return <LoadingPage />;
  return (
    <Box pt="1.5rem">
      <TitleDescription>تصاویر الحاقی</TitleDescription>
      <Box mt="24px">
        <SwitchTab
          activeTab={1}
          tabs={tabs}
          getActiveTab={(activeTab: number) => setActiveTab(activeTab)}
        />
        {activeTab === 1 ? firstTabElement : null}
        {activeTab === 2 ? <ShowDamagedDocumentImagesTab /> : null}
      </Box>
    </Box>
  );
};
